// Auto-generated build information
// This file is generated during the build process - do not edit manually

export const buildInfo = {
  "buildNumber": 1765923980199,
  "buildTime": "2025-12-16T22:26:20.197Z",
  "gitCommit": "889a608c",
  "gitCommitFull": "889a608cd1ab2df0d2c5cca0a503578b1a6f4a3a",
  "gitBranch": "main",
  "nodeVersion": "v22.17.1",
  "environment": "production"
};

export default buildInfo;
